import { get, post } from "@insite/client-framework/Services/ApiService";
import { ConfigurationDataResultModel } from "@tSurya/Store/Data/ConfiguratorModels";

const configuratorUrl = "/api/v2/configurator/configuration-data";
const relatedCylindoFeaturesUrl = "/api/v2/configurator/related-cylindo-features";
const itemAttributesUrl = "/api/v2/configurator/item-attributes";

export interface ConfigurationDataRequest {
    productId: string;
    selections: Record<string, string>;
}

export interface ConfiguratorItemAttributesModel {
    itemId: string;
    attributes: Record<string, string>;
}

export async function postConfigurationData(
    request: ConfigurationDataRequest,
): Promise<ConfigurationDataResultModel> {
    return post<ConfigurationDataRequest, ConfigurationDataResultModel>(configuratorUrl, request);
}

export interface RelatedCylindoFeaturesRequest {
    productIds: string[];
    selections: Record<string, string>;
}

export interface RelatedProductFeaturesModel {
    productId: string;
    validatedSelections: Record<string, string>;
    features: Record<string, string>;
}

export interface RelatedCylindoFeaturesResult {
    results: RelatedProductFeaturesModel[];
}

/**
 * Lightweight batch call: given a set of related product ids and the current PDP
 * selections, returns the validated selections and Cylindo features applicable to
 * each product. Used to apply configurator selections to related-product images.
 */
export async function postRelatedCylindoFeatures(
    request: RelatedCylindoFeaturesRequest,
): Promise<RelatedCylindoFeaturesResult> {
    return post<RelatedCylindoFeaturesRequest, RelatedCylindoFeaturesResult>(
        relatedCylindoFeaturesUrl,
        request,
    );
}

export async function getConfiguratorItemAttributes(
    productId: string,
): Promise<ConfiguratorItemAttributesModel[]> {
    // cache: "default" lets the browser honor the endpoint's Cache-Control/ETag.
    return get<ConfiguratorItemAttributesModel[]>(itemAttributesUrl, {}, { productId }, "default");
}
